<template>
  <div class="product-listing row center-xs start-md"
       :class="currentPartner.display_mode === 'food' ? '': 'm0'">
    <div
      v-for="(product, index) in products"
      :key="product.entity_id"
      :class="currentPartner.display_mode === 'food' ? 'col-sm-6 flex col-xs-12 col-md-6 col-lg-4 brdr-bottom-1 brdr-cl-secondary mb20': 'col-sm-6 flex col-md-3 col-xs-6'"
    >
      <product-tile-grid class="product-tile px10 pt10" :product="product" v-if="currentPartner.display_mode === 'food'" :idx="index"/>
      <product-tile class="product-tile" :product="product" v-else />
    </div>
  </div>
</template>

<script async>
import ProductTile from 'theme/components/core/ProductTile'
import ProductTileGrid from 'theme/components/theme/blocks/Home/ProductTileGrid'
import { mapGetters, mapActions } from 'vuex'
let lastHero = 0
export default {
  name: 'ProductListing',
  components: {
    ProductTile,
    ProductTileGrid
  },
  props: {
    products: {
      type: null,
      required: true
    },
    columns: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner'
    })
  },
  methods: {
    wide (isOnSale, isNew, index) {
      let deltaCondition = index > 0 && ((index - 1) - lastHero) % 2 === 0
      // last image always shouldn't be big, we also need to count from last promoted to check if it will look ok
      let isHero = ((isOnSale === '1' || isNew === '1') && deltaCondition) || (index === this.products.length - 1 && (index - lastHero) % 2 !== 0)
      if (isHero) {
        lastHero = index
      }
      return isHero ? 'col-xs-12' : 'col-xs-6'
    }
  }
}
</script>
